import axios from 'axios'

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api/v1', headers: { 'Content-Type': 'application/json' } })

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('inv_admin_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) { localStorage.removeItem('inv_admin_token'); localStorage.removeItem('inv_admin_user'); window.location.href = '/login' }
    return Promise.reject(err)
  }
)

export default api
